import { render } from "./BaseFieldQuantity.vue?vue&type=template&id=e13b8eae&scoped=true&ts=true"
import script from "./BaseFieldQuantity.vue?vue&type=script&lang=ts"
export * from "./BaseFieldQuantity.vue?vue&type=script&lang=ts"

import "./BaseFieldQuantity.vue?vue&type=style&index=0&id=e13b8eae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.38_typescript@5.9.3__webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e13b8eae"]])

export default __exports__